import { render } from "./SmartHomeView.vue?vue&type=template&id=6482bc2b&scoped=true"
const script = {}

import "./SmartHomeView.vue?vue&type=style&index=0&id=6482bc2b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_webpack@5.112.2_postcss@8.5.32_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6482bc2b"]])

export default __exports__